import { render, staticRenderFns } from "./AppBreadcrumbs.vue?vue&type=template&id=5388acd3&"
import script from "./AppBreadcrumbs.vue?vue&type=script&lang=js&"
export * from "./AppBreadcrumbs.vue?vue&type=script&lang=js&"
import style0 from "./AppBreadcrumbs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBreadcrumbs,VToolbar})
